<template>
  <View align="center" justify="center" class="avatar-placeholder">
    <Icon size="extra-small" :name="icon" />
  </View>
</template>

<script setup lang="ts">
import { IconName } from '../values/icons.const';
import Icon from './icon.vue';
import View from './view/view.vue';

/** Stands where an avatar would be once someone is chosen or added */
defineProps<{ icon: IconName }>();
</script>

<style scoped lang="scss">
.avatar-placeholder {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: var(--t-border-radius-full-rounded);
  border: 1px dashed var(--t-text-color-tertiary);
  color: var(--t-text-color-tertiary);
}
</style>
